/* Progressive presentation only. Native Shopify form + validated File remain intact. */
(() => {
  const finishLabel = value => ({Gold:'18K Gold-Plated',Silver:'Silver Stainless Steel','Rose Gold':'18K Rose-Gold-Plated'})[value] || value;
  function init(root) {
    if (root.dataset.mpnEnhanced) return;
    const details = root.querySelector('[data-mpn-personalizer]');
    if (!details) return;
    const variant = root.querySelector('[data-lf-variant]');
    const demoFinish = root.querySelector('[data-mpn-preview-finish]');
    const demoEngraving = root.querySelector('[data-mpn-preview-engraving]');
    if (!variant && (!demoFinish || !demoEngraving)) return;
    root.dataset.mpnEnhanced = 'true';
    root.querySelectorAll('.mpn-native-variant select').forEach(select => { select.tabIndex = -1; select.setAttribute('aria-hidden', 'true'); });
    const trigger = root.querySelector('[data-mpn-open-personalizer]');
    const chips = root.querySelectorAll('[data-mpn-finish]');
    const engravingChips = root.querySelectorAll('[data-mpn-engraving]');
    const change = element => element.dispatchEvent(new Event('change', {bubbles:true}));
    const optionFinish = option => option?.dataset.finish || option?.textContent.split(' / ')[0].trim();
    const selected = () => variant?.selectedOptions[0];
    const hasBack = () => variant ? selected()?.dataset.back === 'true' : demoEngraving.value === 'back';
    const finish = () => variant ? optionFinish(selected()) : demoFinish.value;
    function sync() {
      const currentFinish = finish(), back = hasBack();
      const price = variant ? selected()?.dataset.price : demoEngraving.selectedOptions[0]?.dataset.price;
      root.querySelectorAll('[data-mpn-finish-label]').forEach(label => label.textContent = finishLabel(currentFinish) || 'Choose a finish');
      root.querySelectorAll('[data-mpn-live-price]').forEach(label => label.textContent = price || '');
      chips.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.mpnFinish === currentFinish));
        button.disabled = variant ? !Array.from(variant.options).some(option => !option.disabled && optionFinish(option) === button.dataset.mpnFinish) : false;
      });
      engravingChips.forEach(button => {
        const wantsBack = button.dataset.mpnEngraving === 'back';
        button.setAttribute('aria-pressed', String(wantsBack === back));
        button.disabled = variant ? !Array.from(variant.options).some(option => !option.disabled && optionFinish(option) === currentFinish && (option.dataset.back === 'true') === wantsBack) : false;
      });
    }
    chips.forEach(button => button.addEventListener('click', () => {
      if (variant) {
        const matching = Array.from(variant.options).filter(option => !option.disabled && optionFinish(option) === button.dataset.mpnFinish);
        const next = matching.find(option => (option.dataset.back === 'true') === hasBack()) || matching[0];
        if (next) {variant.value = next.value; change(variant);}
      } else {demoFinish.value = button.dataset.mpnFinish; change(demoFinish);}
      sync();
    }));
    engravingChips.forEach(button => button.addEventListener('click', () => {
      if (variant) {
        const next = Array.from(variant.options).find(option => !option.disabled && optionFinish(option) === finish() && (option.dataset.back === 'true') === (button.dataset.mpnEngraving === 'back'));
        if (next) {variant.value = next.value; change(variant);}
      } else {demoEngraving.value = button.dataset.mpnEngraving; change(demoEngraving);}
      sync();
    }));
    [variant, demoFinish, demoEngraving].filter(Boolean).forEach(element => element.addEventListener('change', sync));
    trigger?.addEventListener('click', () => {
      if(details.tagName==='DETAILS'){details.open = true;trigger.setAttribute('aria-expanded','true');}
      const upload=details.querySelector('input[type=file]');
      (upload?.closest('[data-mpn-dropzone]')||details).scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      (upload||details.querySelector('summary'))?.focus({preventScroll:true});
    });
    if(details.tagName==='DETAILS')details.addEventListener('toggle', () => trigger?.setAttribute('aria-expanded', String(details.open)));
    root.querySelectorAll('[data-mpn-dropzone]').forEach(zone => {
      const input = zone.querySelector('input[type=file]');
      const hint = zone.querySelector('[data-mpn-upload-hint]');
      const defaultHint = hint?.textContent;
      ['dragenter','dragover'].forEach(type => zone.addEventListener(type, event => {event.preventDefault();zone.dataset.dragging='true';}));
      ['dragleave','dragend'].forEach(type => zone.addEventListener(type, () => delete zone.dataset.dragging));
      zone.addEventListener('drop', event => {
        event.preventDefault();delete zone.dataset.dragging;
        if (!event.dataTransfer?.files?.length) return;
        const transfer = new DataTransfer(); transfer.items.add(event.dataTransfer.files[0]);
        input.files = transfer.files;change(input);
      });
      input.addEventListener('change', () => {if(hint) hint.textContent = input.files[0]?.name || defaultHint;});
      root.querySelectorAll('[data-lf-remove],[data-mpn-preview-remove]').forEach(button => button.addEventListener('click', () => {if(hint) hint.textContent = defaultHint;}));
    });
    sync();
  }
  document.querySelectorAll('[data-mpn-premium-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mpn-premium-product]').forEach(init));
})();
